module.exports = __webpack_public_path__ + "img/jardin13.10fd1466.jpg";